import { useMutation, MutationOptions } from '@apollo/client'

import { SignUpGuestMutation, SignUpGuestMutationVariables } from 'gql'

import { SIGN_UP_AS_GUEST } from 'gql/user/mutations'

const useSignUpAsGuest = (
  options?: MutationOptions<SignUpGuestMutation, SignUpGuestMutationVariables>
) => useMutation<SignUpGuestMutation, SignUpGuestMutationVariables>(SIGN_UP_AS_GUEST, options)

export default useSignUpAsGuest
